



















import { defineComponent } from '@vue/composition-api';
import { PropType } from 'vue';
import TagsContainer from '@/components/common/tags-container/index.vue';
const name = 'ttam-behavior-hashtag-offline-hashtag-alert';
export default defineComponent({
  components: {
    TagsContainer,
  },
  props: {
    tags: {
      type: Array as PropType<Array<any>>,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    return {
      name,
      onClose: () => {
        emit('close');
      },
    };
  },
});
